export default __webpack_public_path__ + "static/media/menu-affogato.71e8ece2.png";